import { RetailStoreOrderDeatils } from './RetailStoreOrder';

export const data: RetailStoreOrderDeatils[] = [];

export const orderStatus =[
'CREATED','INPROGRESS','CONFIRMED'
]
